import styled from 'styled-components';
import BackgroundImage from 'assets/images/auth/img-management-producers.jpg';

export const Container = styled.div`
  .title {
    font-family: ${({ theme }) => theme.font.fontFamily.bold};
    color: ${({ theme }) => theme.font.color.primary};
    font-size: 18px;

    @media screen and (max-width: 520px) {
      font-size: 16px;
    }
  }
`;

export const Banner = styled.div`
  padding: 35px 0 7px 0;
  background-image: url(${BackgroundImage});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0px -167px
`;

export const Wrapper = styled.div`
  max-width: 1200px;
  padding: 0 15px;
  margin: 0 auto;

  > h1 {
    font-family: ${({ theme }) => theme.font.fontFamily.bold};
    color: ${({ theme }) => theme.font.color.primary};
    font-size: 24px;
    margin-left: 5px;
  }

  > p {
    font-family: ${({ theme }) => theme.font.fontFamily.bold};
    color: ${({ theme }) => theme.font.color.primary};
    font-size: 14px;
    margin-left: 5px;
  }
`;

export const FiltersBox = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: start;

  .filter {
    width: 100%;
    max-width: 400px;
    background: #efefef;
    margin: 5px;
    padding: 15px 20px;
    border-radius: 5px;
    font-family: ${({ theme }) => theme.font.fontFamily.bold};
    color: ${({ theme }) => theme.font.color.primary};

    .aplication-top {
      margin-top: 10px;
    }

    > div {
      display: flex;
      .radio-personalizado {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-family: ${({ theme }) => theme.font.fontFamily.regular};
        color: #000;
        margin-bottom: 8px;
        position: relative;

        input[type='radio'] {
          opacity: 0;
          position: absolute;
          pointer-events: none;
        }

        .custom-radio {
          width: 18px;
          height: 18px;
          border: 2px solid #666;
          border-radius: 50%;
          margin-right: 10px;
          box-sizing: border-box;
          transition: all 0.2s ease;
          position: relative;
        }

        input[type='radio']:checked + .custom-radio {
          border-color: ${({ theme }) => theme.font.color.primary};
        }

        input[type='radio']:checked + .custom-radio::after {
          content: '';
          position: absolute;
          top: 2px;
          left: 2px;
          width: 10px;
          height: 10px;
          background-color: ${({ theme }) => theme.font.color.primary};
          border-radius: 50%;
        }

        &:hover .custom-radio {
          border-color: ${({ theme }) => theme.font.color.primary};
        }
      }
    }

    > strong {
      display: block;
      margin-bottom: 8px;
    }

    .select-personalizado {
      display: flex;
      align-items: center;
      background-color: #fff;
      border-radius: 4px;
      overflow: hidden;
      height: 40px;

      select {
        flex: 1;
        height: 100%;
        padding: 0 10px;
        font-family: ${({ theme }) => theme.font.fontFamily.regular};
        color: #000;
        border: none;
        background-color: #fff;
        cursor: pointer;

        &:focus {
          outline: none;
        }
      }

      .clear-btn {
        width: 40px;
        height: 100%;
        background: transparent;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        svg {
          color: #666;
        }

        &:hover svg {
          color: #000;
        }
      }
    }
  }
`;

export const BoxRadio = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;

  > label {
    margin-left: 5px;
  }
`;

export const ProducerBox = styled.div`
  width: 100%;
  background: #efefef;
  margin: 10px;
  border-radius: 5px;
  font-family: ${({ theme }) => theme.font.fontFamily.bold};
  color: ${({ theme }) => theme.font.color.primary};

  .header {
    width: 100%;
    max-width: 300px;
    display: flex;
    flex-direction: column;
    padding: 40px 20px 10px 20px;

    > strong {
      margin-bottom: 10px;
    }

    .select-personalizado {
      position: relative;
      display: flex;
      align-items: center;
      background-color: #fff;
      border-radius: 4px;
      height: 40px;
      overflow: hidden;

      select {
        width: 100%;
        height: 100%;
        padding: 0 40px 0 10px; // espaço à direita para o botão
        font-family: ${({ theme }) => theme.font.fontFamily.regular};
        color: #000;
        border: none;
        background-color: #fff;
        cursor: pointer;

        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;

        &:focus {
          outline: none;
        }
      }

      .clear-btn {
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
        width: 30px;
        height: 30px;
        padding: 0;
        background: transparent;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        svg {
          color: #666;
          width: 16px;
          height: 16px;
        }

        &:hover svg {
          color: #000;
        }
      }
    }
  }

  .body {
    width: 100%;
    background: #fff;
    padding: 40px 0;

    display: flex;
    justify-content: center;
    align-items: center;

    .table {
      width: 100%;
      max-width: 1000px;
      background: #efefef;
      border-radius: 5px;
      padding: 20px;

      display: grid;
      grid-template-rows: auto 1fr;
      grid-template-columns: 1fr 1fr;
      gap: 10px;

      .row-1 {
        grid-row: 1;
        grid-column: 1 / 3;
        padding: 10px;
        width: 100%;
        background: #fff;
        text-align: center;
        position: relative;

        strong,
        h3 {
          color: #000;
        }

        .tooltip {
          position: absolute;
          top: 5px;
          right: 20px;
          display: inline-block;

          .tooltip-button {
            background: none;
            border: none;
            color: ${({ theme }) => theme.font.color.primary};
            cursor: pointer;
            width: 30px;
            height: 30px;
            font-size: 30px;
          }

          .tooltip-text {
            position: absolute;
            top: -35px;
            right: 0;
            background-color: #fff;
            border: 1px solid ${({ theme }) => theme.font.color.primary};
            color: ${({ theme }) => theme.font.color.primary};
            padding: 8px;
            border-radius: 5px;
            font-size: 12px;
            white-space: nowrap;
            visibility: hidden;
            opacity: 0;
            transition: opacity 0.3s;
            z-index: 10;
          }

          &:hover .tooltip-text {
            visibility: visible;
            opacity: 1;
          }
        }
      }

      .row-2 {
        grid-row: 2;
        grid-column: 1 / 2;
        width: 100%;
        background: #fff;

        table {
          width: 100%;
          border-collapse: collapse;

          thead {
            background: #fff;
            tr {
              th {
                width: 100%;
                font-family: ${({ theme }) => theme.font.fontFamily.bold};
                color: ${({ theme }) => theme.font.color.primary};
                padding: 9px;
                border-bottom: 1px solid #efefef;
                text-align: center; /* Ensures the content is centered */
              }
            }
          }

          tbody {
            tr {
              .fill-in-title {
                background: #efefef !important;
                font-size: 13px;
                font-family: ${({ theme }) => theme.font.fontFamily.bold};
                color: ${({ theme }) => theme.font.color.primary};
              }
              td {
                font-family: ${({ theme }) => theme.font.fontFamily.regular};
                color: #000;
                padding: 9px;
                border-bottom: 1px solid #efefef;
                font-size: 13px;
              }
            }
          }
        }
      }

      .row-3 {
        grid-row: 2;
        grid-column: 2 / 2;
        width: 100%;
        background: #fff;

        table {
          width: 100%;
          border-collapse: collapse;

          thead {
            background: #fff;
            tr {
              th {
                width: 100%;
                font-family: ${({ theme }) => theme.font.fontFamily.bold};
                color: ${({ theme }) => theme.font.color.primary};
                padding: 9px;
                border-bottom: 1px solid #efefef;
                text-align: center; /* Ensures the content is centered */
              }
            }
          }

          tbody {
            tr {
              .fill-in-title {
                background: #efefef !important;
                font-size: 13px;
                font-family: ${({ theme }) => theme.font.fontFamily.bold};
                color: ${({ theme }) => theme.font.color.primary};
              }
              td {
                font-family: ${({ theme }) => theme.font.fontFamily.regular};
                color: #000;
                padding: 9px;
                border-bottom: 1px solid #efefef;
                font-size: 13px;
              }
            }
          }
        }
      }
    }
  }

  .body-btn-download {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;

    > button {
      background-color: ${({ theme }) => theme.font.color.primary};
      color: #fff;
      border: none;
      border-radius: 5px;
      font-family: ${({ theme }) => theme.font.fontFamily.bold};
      padding: 15px 35px;
      cursor: pointer;

      &:hover {
        background-color: ${({ theme }) => theme.font.color.primary};
      }
    }
  }
`;
